import { OptionType } from '../types/project';

export const projectStatusOptions: OptionType[] = [
    { label: 'Active', id: 'active' },
    { label: 'Inactive', id: 'inactive' }
];
